<template>
  <ul v-if="visibleBadges.length" class="pc__feature-badges">
    <li
      v-for="(badge, index) in visibleBadges"
      :key="`${badge.text}-${index}`"
      class="pc__feature-badge"
      :style="badgeStyle(badge)"
    >
      {{ badge.text }}
    </li>
  </ul>
</template>

<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    badges: {
      type: Array,
      default: () => [],
    },
  });

  const visibleBadges = computed(() => {
    return (props.badges || []).filter((badge) => badge && badge.text);
  });

  const toCssColor = (value) => {
    if (!value || value === 'null') return undefined;
    if (typeof value === 'string') return value;

    if (typeof value === 'object') {
      if (value.hex) return value.hex.startsWith('#') ? value.hex : `#${value.hex}`;
      if (value.red != null && value.green != null && value.blue != null) {
        if (value.alpha != null && Number(value.alpha) < 1) {
          return `rgba(${value.red}, ${value.green}, ${value.blue}, ${value.alpha})`;
        }

        return `rgb(${value.red}, ${value.green}, ${value.blue})`;
      }
    }

    return undefined;
  };

  const badgeStyle = (badge) => {
    const backgroundColor = toCssColor(badge.background_color);
    const color = toCssColor(badge.text_color);

    return {
      ...(backgroundColor ? { backgroundColor } : {}),
      ...(color ? { color } : {}),
    };
  };
</script>
